import { render, staticRenderFns } from "./FormParcoursclinique.vue?vue&type=template&id=59a29482&"
import script from "./FormParcoursclinique.vue?vue&type=script&lang=js&"
export * from "./FormParcoursclinique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports